export default "__VITE_ASSET__2885efa7__"